import SelectBenchShapePage from '../components/SelectBenchShapePage';
import { connect } from 'react-redux';
import { changeShape,mirrorBench } from '../actions';
import localization from '../helpers/localization.js';
import { getWebpAwareExtension } from '../helpers/webpSupport';

const mapStateToProps = (state, ownProps) => {
    return {
        selections: buildShapes(state.benchModel.availableBenchShapes, state.benchModel.shape),
        selected: state.benchModel.shape.code,
        showPrices: state.clientConfiguration.showPrices,
        prices: state.optionPricing.benchSpapes,
        selectionName: localization.selectBenchShape,
        mirrored: state.benchModel.mirrored,
        canMirrorBench: canMirrorBenchDirectly(state)
    };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
    onChange: (e) => {
        dispatch(changeShape(e));
    },
    mirrorBench: () => {
        dispatch(mirrorBench());       
    }
});

const SelectBenchShapePageContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(SelectBenchShapePage);

export default SelectBenchShapePageContainer;

let canMirrorBenchDirectly = (state) => {
    return state.clientConfiguration.benchMirrorBehavior === "by_mirroring_bench";
}
let currentShapes = {};


let buildShapes = (shapes, active) => {
    if (currentShapes.active !== active || !currentShapes.shapes || shapes.length !== currentShapes.shapes.length) {
        currentShapes.shapes = shapes.map(s => {
            s.id = s.code;
            s.thumbnail = "./img/shapes/" + s.code + getWebpAwareExtension();
            return s;
        }
        );
        currentShapes.active = active;
    }
    return currentShapes.shapes;
}
